import { ComponentType } from 'react'
import { useParams } from 'react-router'

import { TransactionViewProvider } from '@features/transactions/contexts/transactionViewContext'
import { TransactionViewTrackingContext } from '@features/transactions/enums/transactionViewTrackingContext'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { VatDeclarationContextProvider } from '../../context/vatDeclarationContext'
import { VatDeclarationsContextProvider } from '../../context/vatDeclarationsContext'
import { VatDeclarationsRouteProvider } from '../../context/vatDeclarationsRouteContext'
import { SupportedCountries } from '../../types/supportedCountries'
import { VatDeclarationsParams } from '../../types/vatDeclarationsParams'
import { isSupportedCountryId, shouldUseDKReportContent } from '../../utils/isSupportedCountryId'
import { VatDeclarationsEmptyView } from '../VatDeclarationsEmptyView'
import { VatDeclarationSkatWrapper } from './elements/VatDeclarationSkatWrapper'
import {
  VatDeclarationViewDE,
  VatDeclarationViewDK,
  VatDeclarationViewFR,
  VatDeclarationViewNL,
} from './elements/VatDeclarationView'

const COUNTRY_VIEWS: Record<SupportedCountries, ComponentType> = {
  DE: VatDeclarationViewDE,
  DK: VatDeclarationViewDK,
  FO: VatDeclarationViewDK,
  FR: VatDeclarationViewFR,
  GL: VatDeclarationViewDK,
  NL: VatDeclarationViewNL,
}

export const VatDeclaration = () => {
  const { organization } = useUserOrganization()
  const { vatDeclarationId } = useParams<VatDeclarationsParams>()

  if (!vatDeclarationId || !isSupportedCountryId(organization?.countryId) || !organization) {
    return <VatDeclarationsEmptyView />
  }

  const CountryView = COUNTRY_VIEWS[organization.countryId]
  const needsSkatContext = shouldUseDKReportContent(organization.countryId)

  return (
    <VatDeclarationsRouteProvider>
      <VatDeclarationsContextProvider>
        <VatDeclarationContextProvider vatDeclarationId={vatDeclarationId}>
          <TransactionViewProvider trackingContext={TransactionViewTrackingContext.VatAuditTrail}>
            {needsSkatContext ? (
              <VatDeclarationSkatWrapper>
                <CountryView />
              </VatDeclarationSkatWrapper>
            ) : (
              <CountryView />
            )}
          </TransactionViewProvider>
        </VatDeclarationContextProvider>
      </VatDeclarationsContextProvider>
    </VatDeclarationsRouteProvider>
  )
}
